import { graphql } from '@graphql/__generated'

export const CREATE_MEMBERSHIP = graphql(`
  mutation CreateMembership($data: CreateMembershipInput!) {
    createMembership(data: $data) {
      __typename

      ... on CreateMembershipOutput {
        productId
        prices {
          priceAmount
          priceId
          interval
          currency
          priceId
          title
        }
        name
      }

      ... on APIError {
        error
        code
      }
    }
  }
`)
